export {
  HeadingColor,
  HeadingComponent,
  HeadingSize,
  HeadingType,
  HeadingWeight,
} from './heading.component';
